import { render, staticRenderFns } from "./CustomersLocations.vue?vue&type=template&id=4675836a&scoped=true"
import script from "./CustomersLocations.vue?vue&type=script&lang=js"
export * from "./CustomersLocations.vue?vue&type=script&lang=js"
import style0 from "./CustomersLocations.vue?vue&type=style&index=0&id=4675836a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675836a",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon});
